module.exports = __webpack_public_path__ + "img/seo-accordion-content-cjdr.d31ebce0.png";